import classNames from 'classnames';

import {Body} from 'shells/typography/body';
import type {Color, TextSize} from 'shells/typography/body';

interface Props {
    icon: React.ComponentType<any>;
    iconColor?: string;
    text: string | React.ReactNode;
    backgroundColor?: string;
    textStyles?: {
        size?: TextSize;
        color?: Color;
        isItalic?: boolean;
    };
    bodyFill?: boolean;
    rightContent?: React.ReactNode;
}

export const MenuItem = (props: Props) => {
    const Icon = props.icon;

    const BodyComponent =
        typeof props.text === 'string' ? (
            <Body {...props.textStyles}>{props.text}</Body>
        ) : (
            props.text
        );

    const bodyStyles = classNames({
        'flex-grow': props.bodyFill,
    });

    return (
        <div style={{backgroundColor: props.backgroundColor}} tabIndex={-1} className='px-16 py-12'>
            <div className='flex gap-8 align-center'>
                <Icon size={16} alignCenter={true} fill={props.iconColor} />
                <div className='flex justify-sb full-width'>
                    <div className={bodyStyles}>{BodyComponent}</div>
                    {props.rightContent}
                </div>
            </div>
        </div>
    );
};
